import { globalCss } from "./theme";

export const globalStyles = globalCss({
  "*, *::before, *::after": {
    boxSizing: "border-box",
  },

  body: {
    margin: 0,
    padding: 0,
    fontFamily: "$default",

    // Disable the swipe-back gesture in Chrome
    // because this conflicts with the canvas
    overscrollBehaviorX: "none",
  },

  strong: {
    fontWeight: "$medium",
  },
});
